import { InteractiveMapLocationSchema } from "@redotech/redo-common-model/interactive-map-location";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getBlueYonderLocations = {
  name: "getBlueYonderLocations" as const,
  input: z.object({
    draftReturnId: zExt.objectId().nullish(),
    returnId: zExt.objectId().nullish(),
  }),
  output: z.object({ locations: z.array(InteractiveMapLocationSchema) }),
};
